export interface CreditsConfig {
  enabled: boolean;
  currency: string;

  // Credit consumption rules
  consumption: {
    apiCall: {
      costPerCall: number; // Credits consumed per API call
      freeQuotaCalls: number; // Free quota for paid users (0 = all use credits)
    };
  };
}

/** Credits granted on account registration (before any plan is shown). */
// export const REGISTRATION_BONUS_CREDITS = 30; // Disabled - may re-enable in future
export const REGISTRATION_BONUS_CREDITS = 0;

/** Credits granted when starting a Stripe free trial (0 = disabled). */
export const TRIAL_CREDITS = 0;

/** Free trial duration in days (0 = disabled). */
export const FREE_TRIAL_DAYS = 0;

export const creditsConfig: CreditsConfig = {
  enabled: true,
  currency: 'credits',

  // Consumption rules
  consumption: {
    apiCall: {
      costPerCall: 1, // Each API call costs 1 credit
      freeQuotaCalls: 0, // Paid users have no free quota, all use credits
    },
  },
};
